export enum UserAffiliateStatus{
    None = 0,          // درخواست نداده
    Pending = 1,       // در انتظار تأیید
    Approved = 2,      // تأیید شده
    Suspended = 3      // معلق شده
}